var map = {
	"./contact/editInitialValue": 933,
	"./cpo/editInitialValue": 934,
	"./customer/editInitialValue": 935,
	"./forwarderPo/editInitialValue": 936,
	"./incomingInvoice/editInitialValue": 937,
	"./incomingPayment/editInitialValue": 938,
	"./outgoingInvoice/editInitialValue": 939,
	"./outgoingPayment/editInitialValue": 940,
	"./outgoingQuote/editInitialValue": 941,
	"./product/editInitialValue": 942,
	"./receiving/editInitialValue": 943,
	"./shipping/editInitialValue": 944,
	"./spo/editInitialValue": 945,
	"./spoSched/editInitialValue": 946,
	"./vatDeductRecord/editInitialValue": 947,
	"./vendor/editInitialValue": 948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 932;